import moment from 'moment';

export const convertDayToUnix = (days: number, unit: moment.DurationInputArg2 = 'd') => {
  return Math.round(moment.duration(days, unit).asSeconds());
};

export const convertUnixToDate = (unix: number) => {
  return moment.unix(unix);
};

export const checkUnixExpirationDate = (unix: number) => {
  return convertUnixToDate(unix).isBefore(moment());
};
